module.exports = __webpack_public_path__ + "static/media/TileRFID.ecc9cf10.png";